import { useEffect } from "react";
import { ThreePlanogram } from "../store/types";
import { createThreeMesh } from "../store/utils/three";
import { Color } from "src/elements";
import { PlanogramItem } from "@CommonTypes/merchflow/pog/item";
import { urls } from "src/utils/urls";
import { useUser } from "src/atoms/user";

interface FacingProps {
  three: ThreePlanogram;
  x: number;
  y: number;
  z: number;
  item: PlanogramItem;
}

export const Facing = ({ three, x, y, z, item }: FacingProps) => {
  const { user } = useUser();

  useEffect(() => {
    const { mesh, cleanUp } = createThreeMesh({
      scene: three.scene,
      width: item.getWidth(),
      height: item.getHeight(),
      depth: item.getDepth(),
      x,
      y,
      z,
      color: Color.purple100,
      textureUrl: urls.productImage(item.productCode, user.merchantId, "small"),
    });

    mesh.userData = {
      type: "facing",
      item,
    };

    return cleanUp;
  }, [three, x, y, z, item]);

  return null;
};
